<template>
  <header class="text-center mb-4" id="pay-wife">
    <h1 class="main-title">🔥 wife wif kids 🔥</h1>
    <div class="crypto-ticker">
      <div class="tb">
        <span class="ticker-text">📉 BTC: $133,370 📈 | 📉 ETH: $8,888 📉 | 🚀 TON: $250 🚀 | $WIFE? wif kids! 🤱💸</span>
        <span class="ticker-text">📉 BTC: $133,370 📈 | 📉 ETH: $8,888 📉 | 🚀 TON: $250 🚀 | $WIFE? wif kids! 🤱💸</span>
        <span class="ticker-text">📉 BTC: $133,370 📈 | 📉 ETH: $8,888 📉 | 🚀 TON: $250 🚀 | $WIFE? wif kids! 🤱💸</span>
        <span class="ticker-text">📉 BTC: $133,370 📈 | 📉 ETH: $8,888 📉 | 🚀 TON: $250 🚀 | $WIFE? wif kids! 🤱💸</span>
      </div>
    </div>
  </header>
  <div class="flex items-center flex-row gap-4 justify-center">
    <div class="p-2 text-pink-900" style="-webkit-text-stroke: 1px #FFFFFF;
  text-stroke: 1px #FFFFFF; "><b>{{ formattedBalance }}</b> $wife
    </div>
    <ton-connect></ton-connect>
  </div>

  <section class="content mx-auto max-w-4xl">
    <div class="flex flex-col items-center">

      <div class="quotes">
        <div class="quote text-md mb-4">
          «My children are my inspiration and a reflection of the values that matter deeply to me. 💸» <a class="link"
                                                                                                         href="https://www.instagram.com/p/DBj-V7VtlUi/"
                                                                                                         target="_blank">🔗
          inst</a>
        </div>
      </div>
      <div class="text-center"><a class="text-blue-400 underline hover:text-blue-600 font-bold italic" href="https://t.me/wifewifkids" target="_blank">follow me, honey.. 🍯</a></div>
      <div class="image-container md:mr-8 mb-2 md:mb-0" style=" margin-top: 0; ">
        <img src="/wifewifkids.jpg" alt="wifewifkids" class="">
      </div>


      <div class="text-center flex flex-row gap-4 items-center">
        <button class="buy-button" @click="payWife()">PAY $WIFE {{ amount }} 💎</button>
        <div class="flex flex-col">
          <span @click="amount = amount <= 50 ? amount + 1 : amount">🔼</span>
          <span @click="amount = amount > 1 ? amount - 1 : amount">🔽</span>
        </div>
      </div>
      <div class="text-center mt-2 flex flex-row gap-2">
        <span>OR..</span>
        <button class="sell-button text-red-500 font-bold" @click="sell()">DUMP {{formattedBalance}} $WIFE</button>
      </div>

      <div class="quotes">
        <div class="quote text-md mb-4">
          «Recently, I shared a story about how my younger son was surprised to see people on a commercial flight, as he
          had mostly flown on private jets before. I was surprised by the negative comments that followed. 😲» <a
            class="link" href="https://www.instagram.com/p/DBkz-EUt1NJ/" target="_blank">🔗 inst</a>
        </div>
        <div class="quote text-md mb-4">
          «Long time ago, about 20 years ago, I complained to my friend about the world order, sharing my frustrations.
          To which he cheerfully replied to me: « I know, I know. And we live here and win. » That’s been my motto ever
          since. 🐕🔥» <a class="link" href="https://www.instagram.com/p/C-sv0CoNwVv/" target="_blank">🔗 inst</a>
        </div>
        <div class="quote text-md mb-4">
          «Wellbeing of my children is my main priority ❤️» <a class="link"
                                                               href="https://www.instagram.com/p/DAkccSLNNr0/"
                                                               target="_blank">🔗 inst</a>
        </div>
        <div class="quote text-md mb-4">
          «Join me on this journey of exploring the nature of Reality and self-discovery. Together, we can make the
          world a better place! 💫» <a class="link" href="https://www.instagram.com/p/C_xlP5PNrH6/" target="_blank">🔗
          inst</a>
        </div>
      </div>

      <!-- Видеоблок -->
      <div class="flex flex-row items-center gap-4">
        <div class="text-center">
          <a href="#pay-wife" class="buy-button flex flex-col items-center text-2xl" style="display:flex; padding:1rem">
            <span>P</span>
            <span>A</span>
            <span>Y</span>
          </a>
        </div>
        <div class="video-container md:ml-8 mt-4 md:mt-0">
          <img src="/wifewifkids.gif" alt="wife">
        </div>
      </div>

    </div>

    <div class="text-center mt-6">
      <p class="text-red-200 text-sm font-bold">🎭 This site and token are purely satirical and created for entertainment
        purposes only. The token is not associated with, nor endorsed by, the public figure it references, nor does it
        intend to imply any relationship with them.</p>
      <p class="text-red-200 text-sm font-bold">☝️ Disclaimer: This token is not an investment product, and purchasing
        it does not guarantee any financial returns. Buying this token carries a high risk, and the site and its
        creators are not responsible for any financial losses incurred by users.</p>
    </div>

    <div class="text-center mt-6">
      <a href="https://t.me/pocketfi_bot/bigpump?startapp=onetimeusername_1731-eyJjb2luSWQiOiI3OSJ9" target="_blank"
         class="text-blue-400 underline hover:text-blue-600 font-bold italic">go big pump...</a>
    </div>
  </section>
</template>

<script>

import TonConnect from "@/components/TonConnect.vue";
// eslint-disable-next-line no-unused-vars
import {Address, beginCell, TonClient4} from '@ton/ton';

import {getHttpV4Endpoint} from "@orbs-network/ton-access";

export default {
  name: 'App',
  data() {
    return {
      endpoint: null,
      amount: 5
    }
  },
  components: {
    TonConnect
  },
  methods: {
    async getLastBlock() {
      if (this.endpoint == null) this.endpoint = await this.setEndpoint();
      const endpoint = this.endpoint
      const client = new TonClient4({
        endpoint
      });
      let lastBlock = await client.getLastBlock();
      let seqno = lastBlock.last.seqno;
      this.seqno = seqno
      return lastBlock;
    },
    async setEndpoint() {
      const endpoint = await getHttpV4Endpoint({
        network: this.$store.getters.getMode,
      });
      this.endpoint = endpoint;
      return endpoint
    },

    async runContractMethod(address, method, args) {
      const endpoint = this.endpoint
      const client = new TonClient4({
        endpoint
      });
      let lastBlock = await this.getLastBlock()
      return await client.runMethod(
          lastBlock.last.seqno,
          Address.parse(address),
          method,
          args
      );
    },
    async fetchBalance() {
      if(!this.$store.getters.getConnectionStatus) return null;
      let address = this.$store.getters.getUserAddress;
      let result = await this.runContractMethod(
          this.$store.getters.getJettonMaster,
          'get_wallet_address',
          [{type: "slice", cell: beginCell().storeAddress(Address.parse(address)).endCell()}]
      );
      const userWalletAddress = result.result[0].cell.asSlice().loadAddress().toString();
      this.$store.dispatch('setUserWalletAddress', userWalletAddress)
      address = this.$store.getters.getUserWalletAddress;
      let total = 0;
      console.log('userWalletAddress', address)
      result = await this.runContractMethod(
          address,
          'get_wallet_data',
          []
      );
      if (result.result.length === 0) total = 0
      else {
        total = Number(result.result[0].value)
      }
      setTimeout(() => {
        this.$store.dispatch('setUserWalletBalance', Math.floor(total / 1000000000))
      }, 1000)
    },
    async sell() {
      const tonConnectUI = this.$store.getters.getTonConnect;
      let amount = this.$store.getters.getUserWalletBalance
      if(amount == 0) return alert('r u kiddin me, honey?')
      // eslint-disable-next-line no-constant-condition
      else if(1) return open('https://app.ston.fi/swap?chartVisible=false&ft=EQClJXBsceGlL1cx8izzPBrZPVwZ0AJ4CAovvfC1vV51UcFN&tt=TON','_blank').focus();
      let body = beginCell()
          .storeUint(0x742b36d8, 32)
          .storeUint(0, 64)
          .storeCoins(amount * 1000000000)
          .storeCoins(0)
          .storeBit(0)
          .endCell();
      let transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 360,
        messages: [
          {
            address: this.$store.getters.getUserWalletAddress, // sender jetton wallet
            amount: 0.06 * 1000000000, // for commission fees, excess will be returned
            payload: body.toBoc().toString("base64") // payload with jetton transfer body
          }
        ]
      }
      try {
        const result = await tonConnectUI.sendTransaction(transaction);
        console.log(result)
        console.log('sent')
        setTimeout(async () => {
          await this.fetchBalance()
        }, 8000);
      } catch (e) {
        console.log('discard')
        console.error(e);
      }
    },
    async payWife() {
      // eslint-disable-next-line no-constant-condition
      if(1) return open('https://app.ston.fi/swap?chartVisible=false&ft=TON&tt=EQClJXBsceGlL1cx8izzPBrZPVwZ0AJ4CAovvfC1vV51UcFN','_blank').focus();
      let amount = this.amount
      const tonConnectUI = this.$store.getters.getTonConnect;
      const contract = this.$store.getters.getJettonMaster
      if (!this.$store.getters.getConnectionStatus) return tonConnectUI.openModal()
      let body = beginCell()
          .storeUint(0xaf750d34, 32)
          .storeUint(0, 64)
          .storeCoins(amount * 100000 * 1000000000)
          .storeBit(0)
          .storeAddress(Address.parse(this.$store.getters.getUserAddress))
          .endCell();
      console.log(this.$store.getters.getUserAddress)
      let transaction = {
        validUntil: Math.floor(Date.now() / 1000) + 360,
        messages: [
          {
            address: contract, // sender jetton wallet
            amount: amount * 1000000000, // for commission fees, excess will be returned
            payload: body.toBoc().toString("base64") // payload with jetton transfer body
          }
        ]
      }
      try {
        const result = await tonConnectUI.sendTransaction(transaction);
        console.log(result)
        console.log('sent')
        setTimeout(async () => {
          await this.fetchBalance()
        }, 3000);
      } catch (e) {
        console.log('discard')
        console.error(e);
      }
    },
  },
  computed: {
    formattedBalance() {
      let balance = this.$store.getters.getUserWalletBalance
      if(balance > 1000000) return (balance / 1000000).toFixed(0) + 'M'
      if(balance > 100000) return (balance / 1000).toFixed(0) + 'K'
      return balance.toFixed(0)
    }
  },
  mounted() {
    this.setEndpoint();
    setInterval(async () => {
      await this.fetchBalance()
    }, 5000)
  }
}
</script>

<style>
button[data-tc-dropdown-button="true"] {
  background: #ec31f6;
}

button[data-tc-dropdown-button="true"] div {
  color: white
}
div[data-tc-dropdown="true"] ul {
  background: #ec31f6;
}
button[data-tc-dropdown-button="true"] svg {
  display: none;
}
</style>
